import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import en from 'react-phone-number-input/locale/en.json';
import { getCountries, getCountryCallingCode } from 'react-phone-number-input/input';
import { getCurLanuagePhone } from '@ivymobi/orbit-core/business/phoneNumber';
import LCountrySelect from '@ivymobi/orbit-core/components/CountrySelect/countrySelect';



import { checkMemberInTenant } from '@ivymobi/orbit-core/business/user';

// 工具方法
import _, { get } from 'lodash';
import clsx from 'clsx';
import { Form } from '../../components';
import { SendSmsCodeButton } from '../../users/smsCode';
import { Close } from '@mui/icons-material';
import { FormControl, InputLabel, Select, MenuItem, Box, DialogTitle, IconButton, TextField, InputAdornment, Button, Theme } from '@mui/material';
import { createStyles, makeStyles  } from '@mui/styles';
// import { dispatch } from '@ivymobi/orbit-core/util/redux-saga-promise';

// 引用的组件
// import { Form } from '../../components';
// import { SendSmsCodeButton } from '../../users/smsCode';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    boxStyle1: {
      width: '40px', 
      height: '40px', 
      borderRadius: '20px', 
      border: '1px solid #d1d1d1'
    },
    boxStyle2: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'row',
      marginTop: theme.spacing(3.75),
      cursor: 'pointer',
    },
    image1: {
      width: '40px',
      height: '40px',
      padding: '5px'
    }
    
  }),
);

export default function LoginForm(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const {
    user, doSendCode, onSubmit, onClose, share
  } = props;

  // console.log('propspropspropspropspropsprops', props);

  // 语言参数  i18n.language, t是翻译
  const { t, i18n } = useTranslation();
  const lan = i18n.language === 'zh-CN' ? 'zh' : i18n.language;
  const [flush, setFlush] = useState(true);
  const { tenant } = share;
  // const { info } = tenant;
  // const { industries = [] } = info;
  const userPhone = user?.phone;

  // 两个专有判断： 通过tenantID和开启了单点登录（SSOStatus = true）判断是否为ABB智能样本，
  // 如果是（isABBStatus = true）调用接口判断当前手机号是否为ABB成员（isABBMember）
  const [isABBStatus, setIsAbbStatus] = useState(false);
  const [isABBMember, setIsAbbMember] = useState(false);
  const tntID = _.get(share, ['tenant', 'tnt_id'], '');


  

  const { register, handleSubmit, errors, getValues, watch, formState, setValue } = useForm<{
    mobile: string;
    code: string;
    countryCode: string;
  }>({ mode: 'onChange', defaultValues: { mobile: '', code: '', countryCode: '+86' } });
  const mobile = watch('mobile');
  register({ name: 'countryCode' });

  const handleChange = (event) => {
    setValue('countryCode', '+' + event.target.value);
    setFlush(!flush);
    // console.log('======', getValues('countryCode').replace('+', ''));
  };


  // 登录时点击发送验证码方法：
  const checkTenantAndThenDoSendCode = async (mobile, countryCode) => {
    return doSendCode(mobile, countryCode);
  };

  return (
    <>
      <Box zIndex={999} display='flex' justifyContent='space-between' >
        <Box display='flex' justifyContent='center' width='100%'>
          <DialogTitle>
            {/* {'智能样本的登录框'} */}
            {t('auth.signin')}
          </DialogTitle>
        </Box>
        <IconButton onClick={onClose} ><Close /></IconButton>
      </Box>
      <Form 
        onSubmit={(e) => console.log(e)} 
        toolbar={null} 
        defaultValues={formState} pb={3} 
      >
        { !userPhone && 
          <LCountrySelect
            variant='standard'
            name='countryCode'
            i18n={i18n}
            value={getValues('countryCode').replace('+', '')}
            label={t('login.country')}
            handleChange={handleChange}     />
        }
        <TextField 
          variant='standard'
          label={'手机号码'} 
          placeholder={'请输入手机号码'} 
          fullWidth 
          margin="normal"
          name="mobile" 
          required
          inputRef={register({ required: true, minLength: 8 })}
          error={Boolean(errors.mobile)}
          helperText={errors.mobile ? '请输入有效的手机号' : ''}
          InputProps={{
            startAdornment: <InputAdornment position="start">{getValues('countryCode')}</InputAdornment>,
          }}
        />
        { !userPhone && 
          <TextField 
            variant='standard'
            label={'验证码'} 
            placeholder={'请输入验证码'} 
            fullWidth 
            margin="normal"
            name="code" 
            required
            autoComplete="off"
            inputRef={register({ required: true, minLength: 3 })}
            error={Boolean(errors.code)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" style={{ marginBottom: '24px' }}>
                  <SendSmsCodeButton
                    disabled={Boolean((mobile || '').length === 0 || errors.mobile)}
                    // doSendCode={() => doSendCode(mobile)}
                    doSendCode={() => checkTenantAndThenDoSendCode(mobile, getValues('countryCode'))}
                  />
                </InputAdornment>
              )
            }}
          />
        }
        <Box style={{ fontSize: '12px' }}>
          {t('auth.agree')}
          {tntID==='e5127588-684c-40de-8d16-6ee235e09b18'&&<a>ABB根据</a>}
          <a 
            rel="noopener noreferrer"
            target="_blank"
            href={tenant?.tnt_info?.fileurl}
          >
            {`《 ${_.isNil(tenant?.tnt_info?.filename) ? '--' : tenant?.tnt_info?.filename} 》`}
          </a>
          {tntID==='e5127588-684c-40de-8d16-6ee235e09b18'&&<a>处理本人个人信息并可能将个人信息传输至中国境外</a>}
        </Box>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          type="submit"
          onClick={() => {
            onSubmit({ mobile: getValues('mobile'), code: getValues('code'), countryCode: getValues('countryCode') });
          }}
          disabled={!(formState.isValid && formState.isDirty)}
        >
          {/* {'登录'} */}
          {t('auth.signin')}
        </Button>
      </Form>
    </>
  );
}